var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKronai({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.15789C0 1.41384 1.41384 0 3.15789 0H16.8421C18.5862 0 20 1.41384 20 3.15789V16.8421C20 18.5862 18.5862 20 16.8421 20H3.15789C1.41384 20 0 18.5862 0 16.8421V3.15789Z",
    fill: "url(#paint0_linear_3084_25396)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75319 14V6.82297H3.2706V9.98745H3.36522L5.94797 6.82297H7.76676L5.10341 10.0365L7.7983 14H5.98302L4.01704 11.0493L3.2706 11.9604V14H1.75319ZM10.1888 14H8.56275L11.0404 6.82297H12.9958L15.4699 14H13.8439L12.0461 8.46303H11.9901L10.1888 14ZM10.0872 11.1789H13.928V12.3634H10.0872V11.1789ZM18.2459 6.82297V14H16.7285V6.82297H18.2459Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3084_25396",
    x1: 0.95238,
    y1: 0.952381,
    x2: 17.1429,
    y2: 17.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#924FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5314A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKronai);
export default __webpack_public_path__ + "static/media/kronai.af91f42029dd8ddfa6b1d93d7f9f12e4.svg";
export { ForwardRef as ReactComponent };